/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetSchoolsR200ResponseInnerRenaissanceSchoolClientPlatformEnum = {
    Place: 'renaissance_place',
    GrowthPlatform: 'renaissance_growth_platform'
};
/**
 * @export
 */
export const GetSchoolsR200ResponseInnerRenaissanceSchoolClientStarStatusEnum = {
    Enabled: 'star_enabled',
    Disabled: 'star_disabled',
    Unset: 'star_unset'
};
/**
 * Check if a given object implements the GetSchoolsR200ResponseInnerRenaissanceSchoolClient interface.
 */
export function instanceOfGetSchoolsR200ResponseInnerRenaissanceSchoolClient(value) {
    if (!('baseUrl' in value) || value['baseUrl'] === undefined)
        return false;
    if (!('clientId' in value) || value['clientId'] === undefined)
        return false;
    if (!('platform' in value) || value['platform'] === undefined)
        return false;
    if (!('rpid' in value) || value['rpid'] === undefined)
        return false;
    if (!('sharedRosteringEnabled' in value) || value['sharedRosteringEnabled'] === undefined)
        return false;
    if (!('starStatus' in value) || value['starStatus'] === undefined)
        return false;
    return true;
}
export function GetSchoolsR200ResponseInnerRenaissanceSchoolClientFromJSON(json) {
    return GetSchoolsR200ResponseInnerRenaissanceSchoolClientFromJSONTyped(json, false);
}
export function GetSchoolsR200ResponseInnerRenaissanceSchoolClientFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'baseUrl': json['baseUrl'],
        'clientId': json['clientId'],
        'platform': json['platform'],
        'rpid': json['rpid'],
        'sharedRosteringEnabled': json['sharedRosteringEnabled'],
        'starStatus': json['starStatus'],
    };
}
export function GetSchoolsR200ResponseInnerRenaissanceSchoolClientToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'baseUrl': value['baseUrl'],
        'clientId': value['clientId'],
        'platform': value['platform'],
        'rpid': value['rpid'],
        'sharedRosteringEnabled': value['sharedRosteringEnabled'],
        'starStatus': value['starStatus'],
    };
}
